<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container">

                    <div class="modal-header">
                        <slot name="header">
                            default header
                        </slot>
                    </div>

                    <div class="modal-body">
                        <slot name="body">
                            default body
                        </slot>
                    </div>

                    <div class="modal-footer">
                        <slot name="footer">
                            default footer
                            <button class="modal-default-button button" @click="$emit('close')">
                                OK
                            </button>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        props: {},
        data() {
            return {}
        }
    };
</script>
<style lang="scss" scoped>


</style>
<style>
    /*
        .modal-mask {
            position: fixed;
            z-index: 9998;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.6);
            display: table;
            transition: opacity 0.3s ease;
        }

        .modal-wrapper {
            display: table-cell;
            vertical-align: middle;
        }

        .modal-container {
            max-width: 600px;
            margin: 0 auto;
            padding: 20px 30px;
            background-color: #fff;
            border-radius: 2px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
            transition: all 0.3s ease;
            @media only screen and (max-width: 600px) {
                max-width: 100%;
            }
        }

        .modal-header h3 {
            margin-top: 0;
            color: rgba(255, 102, 0, 1);
        }

        .modal-body {
            margin: 20px 0;
            max-height: 300px;
            overflow-y: auto;
        }

        .modal-enter {
            opacity: 0;
        }

        .modal-leave-active {
            opacity: 0;
        }

        .modal-enter .modal-container,
        .modal-leave-active .modal-container {
            -webkit-transform: scale(0.9);
            transform: scale(0.9);
        }
     NEW */
    .modal-mask {
        position: fixed !important;
        z-index: 2000 !important;
        top: 0 !important;
        right: 0 !important;
        bottom: 0 !important;
        left: 0 !important;
        overflow-y: auto !important;
        webkit-transform: translate3d(0, 0, 0) !important;
        background-color: rgba(0, 0, 0, 0.6) !important;
        display: -webkit-box !important;
        display: -moz-box !important;
        display: -ms-flexbox !important;
        display: -webkit-flex !important;
        display: flex !important;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: -webkit-box !important;
        display: -moz-box !important;
        display: -ms-flexbox !important;
        display: -webkit-flex !important;
        display: flex !important;
        margin: auto !important;
        max-width: 100% !important;

        width: 100% !important;
    }

    .modal-container {
        max-width: 600px;
        background-color: #ffffff !important;
        box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.2) !important;
        -webkit-flex: 1 !important;
        -ms-flex: 1 !important;
        flex: 1 !important;
        width: 100% !important;
        margin: 100px auto;
        padding: 20px 30px;

        border-radius: 2px;
         transition: all .3s ease;

    }

    .modal-header h3 {
        margin-top: 0;
        color: rgba(255, 102, 0, 1);
    }

    .modal-body {
        margin: 20px 0;
    }

    .modal-default-button {
        float: right;
    }


    .modal-enter, .modal-leave {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave .modal-container {
        -webkit-transform: scale(0.9);
        transform: scale(0.9);
    }


</style>
